<template>
  <div>
    <el-card>

      <div>
        <el-select
          v-model="warehouse"
          placeholder="Warehouse"
          filterable
          clearable
          @change="changeWarehouse"
          size="mini"
          disabled
          style="margin-right: 10px;">
          <el-option v-for="item in warehouseList"
            :key="item.id"
            :label="item.warehouseName"
            :value="item.id">
          </el-option>
        </el-select>
      </div>

      <el-table
        max-height="650"
        :data="data"
        @cell-click="cellClick"
        :empty-text="$t('general_noData')"
        style="width: 100%">
        <el-table-column
          label="ID"
          type="index"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          sortable
          prop="type.name"
          label="Item Type"
          width="260"
          align="center">
        </el-table-column>
        <el-table-column
          prop="code"
          label="Item Code"
          width="170">
        </el-table-column>
        <el-table-column
          prop="name"
          label="Item Name">
        </el-table-column>
        <el-table-column
          prop="unit.code"
          label="UoM">
        </el-table-column>
        <el-table-column
          prop="onHand"
          label="On Hand Qty">
        </el-table-column>
        <el-table-column
          prop="reorderQtyMin"
          label="Reorder Qty (Min)">
        </el-table-column>
        <el-table-column
          prop="reorderQtyMax"
          label="Reorder Qty (Max)">
        </el-table-column>
        <el-table-column
          width="120"
          label="History"
          align="center">
          <template slot-scope="scope">
            <div @click="setHistory(scope.row)" style="display: flex; justify-content: center; align-items: center; cursor: pointer;">
              <img src="@/assets/img/history.png" alt="History" height="24px">
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <modal-history :historyList='historyList' ref="openHistory"></modal-history>

  </div>
</template>

<script>
  import ModalHistory from '@/components/journalAndGl/historyJournalEntry.vue'
  import axios from 'axios'
  let moment = require('moment')

  export default {
    name: 'Inventory',
    components: {
      ModalHistory,
    },
    data() {
      return {
        moment: moment,
        data: [],
        warehouse: null,

        warehouseList: [],
      }
    },
    methods: {
      async openTab() {
        this.warehouse = +this.$route.query.warehouseId
        await this.getWarehouseList()
        await this.getData()
      },
      async getWarehouseList() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(`api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.warehouseList = data.inventoryList
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async getData() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`api/v1/items/list?companyId=${this.$route.query.companyId}&name=null&typeId=null&warehouseId=${this.$route.query.warehouseId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.data = data.list
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      changeWarehouse(value) {
        if (value === '') this.warehouse = null
        this.getData()
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    },
  }
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  &__label {
    width: 100%;
    height: 170px;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    z-index: 0;

    &:hover {
      border-color: #409EFF;
    }
    .el-icon-upload {
      display: block;
      font-size: 67px;
      color: #C0C4CC;
      margin: 40px 0 16px;
      line-height: 50px;
    }
    span {
      color: #409EFF;
    }
  }
  &.is-dragover{
    border: 1px dashed #409EFF;
    border-radius: 6px;
    .loading__label{
      background-color:rgba(32,159,255,.06);
    }
  }
}
</style>